import * as React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { Datagrid } from 'react-admin'

//import tracker from '../../utils/tracker'
import { CustomDatagridBody } from '../datagrids/customDatagridBody'
import { CustomDatagridRow } from '../datagrids/customDatagridRow'
import { EventAmountCurrencyField } from '../fields/eventAmountCurrencyField'
import { EventDescriptionField } from '../fields/eventDescriptionField'
import { LocalDateField } from '../fields/localDateField'
//import { ViewPaymentField } from '../fields/viewPaymentField'

const useStyles = makeStyles({
  headerRightWithIcon: {
    textAlign: 'center',
    paddingRight: '85px',
  },
})

export const EventInvoiceList = ({ linkDataPayments, ...props }) => {
  const classes = useStyles()

  // const handlePaymentCollectionClick = (record) => {
  //   tracker.event({
  //     action: 'invoice_advance_details_entry_clicked',
  //     category: 'entrySubType',
  //     label: 'invoiceAdvanceStatus',
  //     value: record?.subType,
  //   })
  // }

  return (
    <Datagrid
      {...props}
      body={
        <CustomDatagridBody {...props} row={<CustomDatagridRow {...props} />} />
      }
    >
      <LocalDateField source="date" label={'resources.invoices.events.date'} />
      <EventDescriptionField
        source="type"
        sourceLateFees="lateFees"
        label={'resources.invoices.events.description'}
      />
      <EventAmountCurrencyField
        source="amount"
        label={'resources.invoices.events.amount'}
        headerClassName={classes.headerRightWithIcon}
      />
      {/* <ViewPaymentField
        source="type"
        label=""
        linkDataPayments={linkDataPayments}
        handleClick={handlePaymentCollectionClick}
      /> */}
    </Datagrid>
  )
}
